import React from "react"
import PropTypes from "prop-types"

import { provideMutation } from "store/Mutation"

import FormErrors from "./FormErrors"

const styleSheet = _theme => ({
  fieldset: {
    border: "none",
    padding: 0,
    margin: 0,
  },

  flex: {
    display: "flex",
    flex: 1,

    "& $fieldset": {
      display: "flex",
      flex: 1,
    },
  },
})

class Form extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    flex: PropTypes.bool,
    mutation: PropTypes.object,
    mutationKey: PropTypes.string,
    mutationRef: PropTypes.func,
    rootRef: PropTypes.func,
    showErrors: PropTypes.bool,

    onSubmit: PropTypes.func,
  }

  static defaultProps = { showErrors: true }

  componentDidUpdate(props) {
    // We can't use a fieldset to force elements to be disabled because it
    // doesn't respond to flex box. So we'll force the current input element to
    // blur, keeping track of the most recent element, then restore it when the
    // form is no longer disabled. This should prevent multiple submits while
    // still offering a favorable UX.

    const disabled = this._isDisabled(props)

    // We're about to disable the form, save the element and blur.
    if (!this._wasDisabled && disabled) {
      this._bookmarkActiveElement = document.activeElement

      // Forces the body to take focus
      document.activeElement.blur()
    }

    // We're about to re enable the form, restore the old element.
    if (this._wasDisabled && !disabled) {
      if (document.activeElement === document.body) {
        const input = this._bookmarkActiveElement
        setTimeout(() => input.focus())
      }
      delete this._bookmarkActiveElement
    }

    this._wasDisabled = disabled
  }

  _handleSubmit = e => {
    e.preventDefault()

    const { onSubmit, mutation } = this.props
    if (onSubmit) {
      // Allow any redux actions from input fields to fire before submitting
      setTimeout(() => onSubmit(mutation), 10)
    }
  }

  _isDisabled({ disabled: disabledProp, mutation }) {
    return disabledProp === undefined ? mutation.isSubmitting() : disabledProp
  }

  render() {
    const {
      children,
      classes,
      className: classNameProp,
      disabled: disabledProp,
      flex,
      mutation,
      mutationKey,
      mutationRef,
      rootRef,
      showErrors,

      onSubmit,

      ...otherProps
    } = this.props

    const disabled = this._isDisabled(this.props)

    const className = classnames(
      {
        [classes.flex]: flex,
      },
      classNameProp
    )

    return (
      <form
        className={className}
        disabled={disabled}
        onSubmit={this._handleSubmit}
        ref={rootRef}
        {...otherProps}
      >
        {showErrors ? <FormErrors mutation={mutation} /> : null}
        {children}
        <button style={{ display: "none" }} />
      </form>
    )
  }
}

import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import classnames from "classnames"

export default compose(withStyles(styleSheet), provideMutation())(Form)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Form/Form.js